import React, { useEffect, useState } from 'react';
import { createClient } from '@supabase/supabase-js';

const supabase = createClient(
  'https://bopvbykhekvrayihgfqm.supabase.co',
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJvcHZieWtoZWt2cmF5aWhnZnFtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQ1ODcyOTgsImV4cCI6MjA2MDE2MzI5OH0.PaJUSFBblBC7b74NrvDMNMZNMiLczHItdfJbMWCe5Lw'
);

function NubbiMadnessMulti() {
  const [universes, setUniverses] = useState([]);
  const [allCharacters, setAllCharacters] = useState([]);
  const [characters, setCharacters] = useState([]);
  const [selectedUniverses, setSelectedUniverses] = useState([]);
  const [bracket, setBracket] = useState([]);
  const [currentMatchup, setCurrentMatchup] = useState(0);
  const [winner, setWinner] = useState(null);
  const [round, setRound] = useState(1);
  const [titleMessage, setTitleMessage] = useState("Select up to 8 universes to begin");
  const [tournamentStarted, setTournamentStarted] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const { data: universesData } = await supabase.from('universes').select('*');
      const { data: charactersData } = await supabase.from('characters').select('*');
  
      const validCharacters = charactersData.filter(c => c.name && c.image);
  
      console.log("🔍 Universos detectados en personajes:");
      validCharacters.forEach((c) => {
        console.log(`ID: ${c.id} | Universo: "${c.universo}" | Nombre: ${c.name}`);
      });
  
      console.log("🌌 Códigos de universos en Supabase:");
      universesData.forEach((u) => {
        console.log(`Código: "${u.code}"`);
      });
  
      const enriched = universesData.map(u => {
        const count = validCharacters.filter(
          c =>
            c.universo?.trim().toUpperCase() === u.code.trim().toUpperCase()
        ).length;
        return { ...u, nubbiCount: count };
      });
  
      setUniverses(enriched);
      setAllCharacters(validCharacters);
    };
  
    fetchData();
  }, []);

  const toggleUniverse = (code) => {
    if (selectedUniverses.includes(code)) {
      setSelectedUniverses(selectedUniverses.filter(c => c !== code));
    } else if (selectedUniverses.length < 8) {
      setSelectedUniverses([...selectedUniverses, code]);
      
    }
    
  };

  const startBracket = () => {
    const selectedCharacters = allCharacters.filter(c =>
      selectedUniverses.includes(c.universo?.toUpperCase())
    );
    const shuffled = selectedCharacters.sort(() => 0.5 - Math.random());
    const top64 = shuffled.slice(0, 64);

    setCharacters(top64);
    setBracket(top64);
    setCurrentMatchup(0);
    setRound(1);
    setWinner(null);
    setTournamentStarted(true);
    setTitleMessage("Round of 64");
  };

  const handleVote = (selected) => {
    const updatedNextRound = [...(window.nextRoundBracket || [])];
    updatedNextRound.push(selected);
    window.nextRoundBracket = updatedNextRound;

    const nextMatch = currentMatchup + 1;

    if ((nextMatch * 2) >= bracket.length) {
      const newRound = round + 1;
      if (bracket.length === 2) {
        setWinner(selected);
        return;
      }
      setTimeout(() => {
        setBracket(window.nextRoundBracket);
        setCurrentMatchup(0);
        setRound(newRound);
        window.nextRoundBracket = [];
        if (newRound === 2) setTitleMessage("Ready for the Round of 32?");
        else if (newRound === 3) setTitleMessage("Time for the Sweet 16!");
        else if (newRound === 4) setTitleMessage("Let’s go Elite 8!");
        else if (newRound === 5) setTitleMessage("Final Four is here!");
        else if (newRound === 6) setTitleMessage("The Final! Choose your Nubbi Champion!");
      }, 600);
    } else {
      setCurrentMatchup(nextMatch);
    }
  };

  if (winner) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <h2 style={{ fontSize: '1.8rem' }}>🏆 Your Nubbi Champion 🏆</h2>
        <img
          src={winner.image}
          alt={winner.name}
          style={{ width: '100%', maxWidth: 200, borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.15)' }}
        />
        <h3 style={{ fontWeight: 'bold', marginTop: '0.5rem' }}>{winner.name}</h3>
        <div style={{ marginTop: '1.5rem' }}>
          <button style={{ margin: '0 10px', padding: '10px 20px', backgroundColor: '#3b82f6', color: 'white', borderRadius: 8 }}>Post it to Facebook</button>
          <button style={{ margin: '0 10px', padding: '10px 20px', backgroundColor: '#22c55e', color: 'white', borderRadius: 8 }}>Send to WhatsApp</button>
          <button style={{ margin: '0 10px', padding: '10px 20px', backgroundColor: '#ec4899', color: 'white', borderRadius: 8 }}>Send to Instagram</button>
          <button style={{ margin: '0 10px', padding: '10px 20px', backgroundColor: '#6b7280', color: 'white', borderRadius: 8 }}>Send through Mail</button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h2 style={{ fontSize: '1.8rem', marginBottom: '1.5rem' }}>{titleMessage}</h2>
      {!tournamentStarted ? (
        <>
          <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 16 }}>
            {universes.map(u => (
              <button
                key={u.code}
                onClick={() => toggleUniverse(u.code)}
                style={{
                  width: 180,
                  padding: 12,
                  borderRadius: 12,
                  background: selectedUniverses.includes(u.code) ? '#fde68a' : '#f4f4f4',
                  border: '2px solid #ccc',
                  textAlign: 'center',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                }}
              >
                <img
                  src={u.image_url}
                  alt={u.name}
                  style={{ width: '100%', height: 'auto', borderRadius: 12, marginBottom: 8 }}
                />
                <strong>{u.code}</strong>
                <div style={{ fontSize: '0.85rem' }}>Nubbis: {u.nubbiCount}</div>
              </button>
            ))}
          </div>
          <div style={{ marginTop: '2rem' }}>
            <button
              onClick={startBracket}
              disabled={selectedUniverses.length === 0}
              style={{
                padding: '12px 24px',
                fontSize: '1rem',
                fontWeight: 'bold',
                backgroundColor: '#22c55e',
                color: 'white',
                border: 'none',
                borderRadius: 24,
                cursor: selectedUniverses.length > 0 ? 'pointer' : 'not-allowed'
              }}
            >
              Start Tournament
            </button>
          </div>
        </>
      ) : (
        <div style={{ display: 'flex', justifyContent: 'center', gap: 32, flexWrap: 'wrap' }}>
          {[0, 1].map(i => {
            const char = bracket[currentMatchup * 2 + i];
            return (
              <div
                key={char?.id || i}
                onClick={() => handleVote(char)}
                style={{
                  width: 220,
                  cursor: 'pointer',
                  textAlign: 'center',
                  borderRadius: 12,
                  border: '2px solid #ccc',
                  padding: 12,
                  boxShadow: '0 4px 10px rgba(0,0,0,0.1)'
                }}
              >
                <img src={char.image} alt={char.name} style={{ width: '100%', borderRadius: 12 }} />
                <p style={{ fontWeight: 'bold', marginTop: 8 }}>{char.name}</p>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default NubbiMadnessMulti;



